import React from 'react'
import { Modal, Button, Typography, Space } from 'antd'
import GseSubmissionBadge from './GseSubmissionBadge'
import NoSubmissionsWarning from './NoSubmissionsWarning'
import { getSuccessfulGseSubmissions } from './utils'

const { Title, Text } = Typography

const CompleteDataCollectionModal = ({
  visible,
  onCancel,
  onContinue,
  inspectionSubmissionsData,
  isLoading,
}) => {
  const successfulSubmissions = getSuccessfulGseSubmissions(inspectionSubmissionsData)
  const hasSuccessfulSubmissions = successfulSubmissions.length > 0

  return (
    <Modal
      title="Complete Data Collection"
      visible={visible}
      onCancel={onCancel}
      data-testid="complete-data-collection-modal"
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="continue"
          type="primary"
          onClick={onContinue}
          loading={isLoading}
          data-testid="complete-data-collection-continue-button"
        >
          Continue
        </Button>,
      ]}
    >
      <Title level={5}>GSE Submission Status</Title>

      {hasSuccessfulSubmissions ? (
        <>
          <Text style={{ display: 'block', marginBottom: '12px' }}>
            The following GSE submissions have been completed successfully:
          </Text>
          <Space direction="vertical" size="small">
            {successfulSubmissions.map((submission) => (
              <GseSubmissionBadge key={submission._id} submission={submission} />
            ))}
          </Space>
        </>
      ) : (
        <NoSubmissionsWarning />
      )}
    </Modal>
  )
}

export default CompleteDataCollectionModal
